/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function() {
  // Sur une fiche produit, affiche et masque les sous-rubrique des descriptions
   $('.cat_title').click(function (e) {
      // Si le bloc juste en-dessous du clic est fermé
      if(!$(this).next(".Rte").hasClass("opened")){

         // On ferme tous les Rte ouverts
         $(".Rte.opened").slideToggle(300, "swing", function() {
            $(this).removeClass("opened");
         });

         // On met un "+" sur tous les titres
         $('.cat_title').removeClass("open");

         // Ouvre le rte suivant
         $(this).next(".Rte").slideToggle().addClass("opened");

         // On met un "-" sur le titre cliqué
         $(this).addClass("open");
      }
   });

   // Bloc texte SEO
  //$(".read_more").click(function() {
    //  $(this).prev(".content_deploy").toggleClass("extend");
   //});

});

//Text wrapper
$(document).ready(function(){
  $(".hide-txt").each(function(){
    $(this).parent().find(".txtcol").show();
  });
  $(".txtcol").click(function(){
    if($(this).prev().hasClass("truncate")) {
            $(this).parent().find(".hide-txt").css("max-height", "1800px");
            $(this).children('a').text("réduire");
        } else {
            $(this).parent().find(".hide-txt").css("max-height", "4.3em");
            $(this).children('a').text("lire la suite");
        }
  $(this).prev().toggleClass("truncate");

  });
});

